import { tv } from '@/ui/utils'

export const screenStyles = tv({
	slots: {
		base: 'flex bg-ground web:w-full',
		keyboardAvoidingView: 'flex h-full w-full',
		screenContainer: 'flex h-full w-full',
		screenContent: 'h-full w-full',
	},
})
